import { useState, useEffect } from "react";
import EyeIcon from '../../assets/icons/eyeIcon.svg';
import UploadIcon from '../../assets/icons/uploadIcon.svg';
import VerticalDivider from '../../assets/icons/verticalDivider.svg';
export default function UseBilling() {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      const updateSize = () =>
        setSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      useEffect(() => (window.onresize = updateSize), []);
    const invoices = [
        {
            period: 'Feb 28-Mar 30, 2022',
            billingGroup: 'Default billing group for securityscorecard-257i',
            state: 'Estimate',
            amount: '$44.68',
            tax: '$10.72',
            total: '$55.40',
            eyeIcon: EyeIcon,
            uploadIcon: UploadIcon,
            verticalDivider: VerticalDivider,
        },
        {
            period: 'Feb 28-Mar 30, 2022',
            billingGroup: 'Default billing group for securityscorecard-257i',
            state: 'Estimate',
            amount: '$44.68',
            tax: '$10.72',
            total: '$55.40',
            eyeIcon: EyeIcon,
            uploadIcon: UploadIcon,
            verticalDivider: VerticalDivider,
        },
        {
            period: 'Feb 28-Mar 30, 2022',
            billingGroup: 'Default billing group for securityscorecard-257i',
            state: 'Estimate',
            amount: '$44.68',
            tax: '$10.72',
            total: '$55.40',
            eyeIcon: EyeIcon,
            uploadIcon: UploadIcon,
            verticalDivider: VerticalDivider,
        },
    ]
    const credits = [
        {
            credits: 'Feb 28-Mar 30, 2022',
            creditType: 'Free trial credits',
            credit: '$300.00',
            remainingCredit: '$200.68',
            creditStartDate: '------',
            creditExpiryDate: '------',
        },
        {
            credits: 'Feb 28-Mar 30, 2022',
            creditType: 'Free trial credits',
            credit: '$300.00',
            remainingCredit: '$200.68',
            creditStartDate: '------',
            creditExpiryDate: '------',
        },
        {
            credits: 'Feb 28-Mar 30, 2022',
            creditType: 'Free trial credits',
            credit: '$300.00',
            remainingCredit: '$200.68',
            creditStartDate: '------',
            creditExpiryDate: '------',
        },
    ]

    const invoicesHeadings = [
        'Period',
        'Billing Group',
        'State',
        'Amount',
        'Tax',
        'Total',
        '',
    ]
    const creditsHeadings = [
        'Credits',
        'Credit type',
        'Credit',
        'Remaining Credit',
        'Credit Start Date',
        'Credit Expiry Date',
    ]
    const BillingCreditHeading = [
        "Credit Code",
        "Credit Type",
        "Credit",
        "Remaining Credit",
        "Credit Start Date",
        "Credit Expiry Date"
    ]
    const BillingCredits = [
        {
            CreditCode: "Welcome-tz3nshgyuae",
            CreditType: "Free trial credits",
            Credit: "$440.68",
            RemainingCredit: "$280.00",
            CreditStartDate: "",
            CreditExpiryDate: ""
        },
        {
            CreditCode: "Welcome-tz3nshgyuae",
            CreditType: "Free trial credits",
            Credit: "$440.68",
            RemainingCredit: "$280.00",
            CreditStartDate: "",
            CreditExpiryDate: ""
        },
        {
            CreditCode: "Welcome-tz3nshgyuae",
            CreditType: "Free trial credits",
            Credit: "$440.68",
            RemainingCredit: "$280.00",
            CreditStartDate: "",
            CreditExpiryDate: ""
        },
    ]
    return [{ invoices, credits, invoicesHeadings, creditsHeadings, BillingCreditHeading, BillingCredits,size }]
}
